import types from './ActionTypes';
import coursesListToMap from 'Utils/CoursesListToMap';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';

export function loadCoursesListRequest() {
    return dispatch => {
        let coursesListUrl = '/courseware/student_courses_json';
        return fetch(coursesListUrl)
            .then(response => response.json())
            .then(courses => {
                let coursesList = JSON.parse(courses['courses']);
                let coursesMap = coursesListToMap(coursesList);
                dispatch(loadCoursesListSuccess(coursesMap));
            }).catch(error => {
                throw(error);
            });
    };
};

export function unRegisterCourseRequest(courseId) {
    return dispatch => {
        let url = `/courseware/api/course/${courseId}/deregister`;
        fetch(url)
            .then(response => response.json())
            .then(result => {
                if (result['message']=="AuthentcationError"){
                    window.location.href = `/accounts/login`;
                }
                else if(result['message']=="Error"){
                    displayGlobalMessage('The course could not be unenrolled.', 'error');
                }
                else{
                    dispatch(unRegisterCourseSuccess(courseId));
                    displayGlobalMessage('The course was successfully unenrolled.', 'success');
                }
            })
            .catch(error => {
                displayGlobalMessage('The course could not be unenrolled.', 'error');
                throw(error);
            });
    };
};

export function unRegisterCourseSuccess(courseId) {
    return {type:types.UNREGISTER_COURSE_SUCCESS, courseId};
}

export function loadCoursesListSuccess(studentCoursesMap) {
    return {type:types.LOAD_STUDENT_COURSES_LIST_SUCCESS, studentCoursesMap};
};

export function loadCoursesListFailure() {
    return {type: types.LOAD_STUDENT_COURSES_LIST_FAILURE};
};
